import { Flex, useDisclosure } from "@chakra-ui/react";
import { FieldProps } from "@rjsf/utils";
import type { JSONSchema7Definition } from "json-schema";
import { FormattedMessage } from "react-intl";

import { RanaButton, TrashIcon } from "@nens/ranalib";

import { useDatasetQuery } from "@/queries/query-dataset";

import { ProjectProcessRunFormDatasetSelectorModal } from "./components/process-run-form-dataset-selector-modal";

export type DatasetValue = { id: string; input_type: "dataset" };

const getIsNullable = (property: JSONSchema7Definition) => {
  if (typeof property === "boolean") return false;
  return property.type === "null" || property.type?.includes("null");
};

export const ProjectProcessRunFormDatasetSelector = (props: FieldProps<DatasetValue>) => {
  const { disabled, readonly, formData, onChange, schema } = props;
  const disclosure = useDisclosure();
  const { data: dataset } = useDatasetQuery(formData?.id);

  const isNullable =
    getIsNullable(schema) || schema.anyOf?.some(getIsNullable) || schema.oneOf?.some(getIsNullable);

  const showDeleteButton = formData?.id && isNullable && !disabled && !readonly;

  return (
    <>
      <ProjectProcessRunFormDatasetSelectorModal {...disclosure} {...props} />

      <Flex alignItems="center" gap={2}>
        {!disabled && !readonly && (
          <RanaButton variant="secondary" onClick={disclosure.onOpen} mt="1">
            {formData?.id ? (
              <FormattedMessage id="process.change" defaultMessage="Change" />
            ) : (
              <FormattedMessage id="process.select_dataset" defaultMessage="Select dataset" />
            )}
          </RanaButton>
        )}
        {dataset?.resourceTitleObject._default}

        {showDeleteButton && (
          <RanaButton onClick={() => onChange(undefined)} variant="tertiary">
            <TrashIcon color="red" />
          </RanaButton>
        )}
      </Flex>
    </>
  );
};
